import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';
import { CartUpdateEvent } from '@theme/events';

class UpsellForkliftComponent extends Component {
  #onChangeBound = this.#onChange.bind(this);

  connectedCallback() {
    super.connectedCallback();
    const checkbox = this.querySelector('.forklift-checkbox');
    if (checkbox) checkbox.addEventListener('change', this.#onChangeBound);
    this.#syncFromCart();
  }

  disconnectedCallback() {
    const checkbox = this.querySelector('.forklift-checkbox');
    if (checkbox) checkbox.removeEventListener('change', this.#onChangeBound);
    super.disconnectedCallback();
  }

  async #syncFromCart() {
    try {
      const checkbox = /** @type {HTMLInputElement|null} */ (this.querySelector('.forklift-checkbox'));
      const variantId = Number(this.dataset.variantId);
      if (!checkbox || !variantId) return;
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const rawItems = cart?.items ?? [];
      /** @type {Array<{id: number|string}>} */
      const items = Array.isArray(rawItems) ? rawItems : [];
      const present = items.some((it) => Number(it.id) === variantId);
      checkbox.checked = present;
    } catch (_) {}
  }

  /** @param {Event} event */
  async #onChange(event) {
    const target = /** @type {HTMLInputElement} */ (event.target);
    if (!(target instanceof HTMLInputElement)) return;

    const variantId = Number(this.dataset.variantId);
    if (!variantId) return;

    target.disabled = true;

    // Collect sections for live cart morphing
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = new Set();
    cartItemsComponents.forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    });

    try {
      let response, data;

      // Normalize URLs in case theme routes don't include .js
      const addUrl = Theme.routes.cart_add_url;
      const updateUrl = Theme.routes.cart_update_url?.endsWith('.js')
        ? Theme.routes.cart_update_url
        : `${Theme.routes.cart_update_url}.js`;

      if (target.checked) {
        // Add via cart_add
        const addBody = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: Array.from(sectionIds),
          sections_url: window.location.pathname,
        });
        response = await fetch(addUrl, fetchConfig('json', { body: addBody }));
        data = await response.json();
      } else {
        // Remove via cart_update
        const updateBody = JSON.stringify({
          updates: { [variantId]: 0 },
          sections: Array.from(sectionIds),
          sections_url: window.location.pathname,
        });
        response = await fetch(updateUrl, fetchConfig('json', { body: updateBody }));
        data = await response.json();
      }

      // Dispatch cart update
      this.dispatchEvent(
        new CartUpdateEvent({}, this.dataset.blockId || this.id || '', { sections: data.sections, variantId: String(variantId) })
      );
    } catch (error) {
      console.error('Forklift upsell error:', error);
    } finally {
      await this.#syncFromCart();
      target.disabled = false;
    }
  }
}

if (!customElements.get('upsell-forklift-component')) {
  customElements.define('upsell-forklift-component', UpsellForkliftComponent);
}